export default {
  title: {
    login: "%{school} - Eingang",
    registration: "%{school} - Anmeldung",
    subjects: "%{school} - Fächerauswahl",
    subject: "%{school} - Fach",
    offer: "%{school} - Vorschlag",
    home: "%{school} - Startseite",
    dictionary: "%{school} - Wörterbuch",
    events: "%{school} - Veranstaltungen",
    news: "%{school} - Nachrichten",
    profile: "%{Schule} - Profil",
    learn: "%{school} - Ausbildung",
    pay: "%{school} - Zahlung für den Kurs",
    checkInSystem: "Bitte geben Sie Ihre E-Mail ein",
    setPassword: "Geben Sie Ihr Passwort ein, um sich anzumelden.",
    createAccount: "Geben Sie Ihre Kontodaten an/aktualisieren Sie sie.",
  },
  authCheckEmail: {
    title: "Geben Sie Ihre E-Mail-Adresse ein",
    emailCaption: "E-Mail Adresse",
    continue: "Fortsetzung folgt",
    or: "oder",
  },
  authPassword: {
    title: "Bei Ihrem Konto anmelden",
    inputCaption: "Passwort",
    placeholder: "Geben Sie Ihr Passwort ein",
    forgot: "Haben Sie Ihr Passwort vergessen?",
    submit: "Eintragen",
  },
  authRegistration: {
    title: "Registrierung eines Kontos",
    name: "Name",
    phone: "Rufnummer",
    password: "Erfinden Sie ein Passwort",
    confirmPassword: "Wiederholen Sie das Passwort, das Sie sich ausgedacht haben",
  },
  totalError: "Hoppla, etwas ist schiefgelaufen!",
  subjectChangeError: "Das Fach konnte nicht gewechselt werden. Bitte versuchen Sie es erneut oder wenden Sie sich an Ihre Schule.",
  email: "E-Mail",
  personalLink: "Persönliche Referenz",
  login: "Anmeldung",
  name: "Name",
  firstLastName: "Nachname und Vorname",
  phone: "Telefon",
  formatPhone: "Die Rufnummer hat das Format 998...", // for leader-online
  aboutMe: "Über mich",
  fullAge: "Ihr Alter (volle Jahre)",
  errorAge: "falsches Alter",
  notNumber: "der Wert muss eine Zahl sein",
  registration: "Anmeldung",
  password: "Passwort",
  currentPassword: "Aktuelles Passwort",
  newPassword: "Neues Passwort",
  confirmPassword: "Wiederholen Sie das Passwort",
  confirmNewPassword: "Wiederholen Sie das neue Passwort",
  forgotPassword: "Haben Sie Ihr Passwort vergessen?",
  passwordsMatch: "Die Passwörter stimmen nicht überein",
  resetPassword: "Passwort erfolgreich zurückgesetzt, bitte überprüfen Sie Ihre E-Mail.",
  resetConfirm: "Möchten Sie Ihr Passwort zurücksetzen?",
  enter: "Eintragen",
  studentEnter: "Eingang für Schüler",
  check: "Weitere",
  signInWithGoogle: "Mit Google anmelden",
  emailIsNotRegistered: "Es gibt keinen Benutzer mit dieser Adresse",
  logout: "Aussteigen",
  online: "online",
  offline: "offline",
  cancel: "Abschaffung von",
  yes: "Ja",
  no: "Nein",
  course: "Kurs",
  dictionary: "Wörterbuch",
  events: "Veranstaltungen",
  news: "Nachrichten",
  words: "Wörter",
  wordsAreHere: "Diese Worte finden sich hier:",
  allWords: "Alle Wörter",
  phrases: "Phrasen",
  videos: "Video",
  exercises: "Übungen",
  theory: "Theorie",
  theoryAlt: "Synopse",
  theoryAdditionalFile: "Zusätzliche Datei herunterladen (%{filename})",
  topic: "Thema",
  lesson: "Lektion",
  lessons: "Lektionen",
  profile: "Profil",
  orders: "Käufe",
  payment: "Zahlung",
  leaderboard: "Leiter",
  leaderboardPerDay: "Die Spitzenreiter des Tages",
  time: "Zeit",
  points: "Punkte",
  myPoints: "Meine Punkte für den gesamten Zeitraum",
  coins: "Münzen",
  courses: "Meine Kurse",
  loading: "Laden...",
  noTheory: "Es gibt keine Theorie zu dieser Lektion",
  startTraining: "Beginn der Ausbildung",
  chat: {
    // === chat list / dialog additions ===
    startDialogTitle: "Chat starten",
    startDialogTooltip: "Neues Gespräch beginnen",
    messages: "Nachrichten",
    unreadOnly: "Nur ungelesene",
    delete: "Löschen",
    send: "Senden",
    sendHelper: "Strg+Enter, um eine Nachricht zu senden",
    close: "Schließen",
    profile: "Profil",
    lastActivity: "Letzte Aktivität",
    status: "Status",
    jobTitle: "Berufsbezeichnung",
    tabLabel: "Chat",
    lastOnline: {
      time: "Zuletzt online um %{date}",
      weekday: "Zuletzt online am %{date}",
      dayMonth: "Zuletzt online am %{date}",
      monthYear: "Zuletzt online im %{date}",
    },
    read: "Lesen Sie",
    errors: {
      wrongFormatting: "Nachricht enthält falsches Format",
    },
  },
  branches: "Themen",
  easy: "Einfach",
  expert: "Experte",
  wordToLearn: "Lernen Sie es später",
  iKnowWord: "Ich kenne dieses Wort.",
  videoVocabulary: "Video-Wortschatz",
  markVideoWatched: "Als angesehen markieren",
  videoWatched: "Angesehen",
  passed: "bestanden",
  unsupportedExercise: "Diese Art von Übung (%{type}) wird noch nicht unterstützt",
  changeCourse: "Kurs ändern",
  currentCourse: "Aktueller Kurs",
  allSubjects: "Alle Fächer",
  all: "Alle",
  subject: "Fäch",
  group: "Gruppe",
  start: "Start",
  chooseSubject: "Wählen Sie das gewünschte Studienfach",
  hourValue: "%{value} h",
  completed: "Abgeschlossen",
  notCompleted: "Nicht abgeschlossen",
  paidBranch: "Dieses Thema ist ein kostenpflichtiges Thema. Bitte kaufen Sie es zum Lernen.",
  buyBranch: "Kaufen Sie ein Thema für %{price} %{currency}",
  paidSubject: "Dieser Kurs ist gebührenpflichtig. Bitte kaufen Sie ihn zum Lernen.",
  buySubject2: "Einen Artikel für %{price} %{currency} kaufen",
  decksItemNotOpen: "Um diese Lektion zu öffnen, müssen Sie die vorherige Lektion abgeschlossen haben",
  decksItemNotPurchasedBranch: "Das Thema dieser Lektion ist blockiert",
  decksItemNotOpenLevel: "Gehe durch das vorherige Level, um die Lektion freizuschalten",
  decksItemNotOpenBranch: "Um diese Lektion zu beginnen, müssen Sie das vorherige Thema durchgehen",
  deckAccessDenied: "Diese Lektion ist für Sie noch nicht verfügbar",
  openOnDate: "Wird freigeschaltet %{date}",
  levelAccessIsDenied: "Materialien auf dieser Ebene sind für Sie nicht verfügbar",
  youAreDeactivated: "Ihr Konto wurde deaktiviert, bitte kontaktieren Sie Ihre Schule",
  youAreDeactivatedShort: "Ihr Konto wurde deaktiviert",
  youAreHaveNotPaidOffers: "Sie haben hervorragende Angebote",
  yourCertificates: "Ihre Zertifikate",
  emptyDeck: "Die Klasse ist leer",
  nextDeck: "Nächste Lektion",
  next: "Weitere",
  proceed: "Fortsetzung folgt",
  skip: "Überspringen",
  more: "Mehr",
  exit: "Ausgabe",
  details: "Mehr lesen",
  go: "Gehe zu",
  profileEdit: "Ein Profil bearbeiten",
  userInfo: "Informationen für den Benutzer",
  of: "von",
  back: "Zurück",
  levelPackExist: "Sie haben bereits die folgenden Stufen",
  awaitingPayment: "Ausstehende Zahlung",
  bought: "Gekauft",
  boughtUntilDate: "Gekauft vor %{endDate}",
  availableUntilDate: "verfügbar vor %{endDate}",
  showMore: "mehr anzeigen",
  hide: "aufrollen",
  communication: "Kontaktperson zur Schule",
  askQuestion: "Eine Frage stellen",
  noDescription: "Keine Beschreibung",
  description: "Beschreibung:",
  onePerMonth: "Monatsabonnement",
  semiannually: "Halbjahresabonnement",
  onceAYear: "Jahresabonnement",
  stopSubscribe: "Stop Abonnieren",
  enable: "Aktivieren Abonnieren",
  expired: "Abgelaufen",
  buySubject: "Einen Artikel kaufen",
  buyOffer: "Kaufen",
  subscribeOffer: "Angebot abonnieren",
  firstPayment: "Erste Tranche",
  accessDaysWarning: "%{smart_count} Tag übrig |||| %{smart_count} Tage übrig",
  accessDemoDaysWarning: "Demo: %{smart_count} Tage übrig |||| Demo: %{smart_count} Tage übrig",
  accessDemoButton: "Demo-Zugang",
  closeButton: "Schließen Sie",
  existOffer: "Es gibt bereits ein unbezahltes Angebot",
  loginInProcess: "Anmeldung läuft...",
  done: "Erledigt:",
  Levels: {
    empty: "In diesem Kurs sind derzeit keine Level verfügbar.",
    name: "Niveau:",
  },
  Decks: {
    scormPass: "Lektion Kredit",
    proceed: "Fortsetzen",
    stayHere: "Hier bleiben",
  },
  Exercises: {
    tabTitle: "Übungen",
    skip: "Weiter",
    check: "Überprüfen Sie es",
    examCheck: "Senden",
    typeAnswer: "Geben Sie Ihre Antwort ein",
    next: "Weitere",
    rightAnswerWas: "Die richtige Antwort war:",
    showRightAnswer: "Richtige Antwort anzeigen",
    rightAnswer: "Richtige Antwort:",
    congratulation: "Herzlichen Glückwunsch!",
    congratText: "Du hast alle Übungen in dieser Lektion gelernt!",
    wrongAnswer: "Ihre Antwort ist falsch",
    answerSaved: "Die Antwort lautet: gespeichert",
    commentToAnswer: "Kommentieren Sie die ausgewählte Antwort:",
    appendix: {
      pdf: {
        tooltipButton: "Ergänzende Materialien",
      },
    },
    type13: {
      title: "Füllen Sie die Lücken aus, indem Sie das richtige Wort aus der Dropdown-Liste auswählen",
    },
    type12: {
      title: "Lesen Sie mehr Informationen",
    },
    type11: {
      title: {
        select: "Wählen Sie die richtige Antwort",
        keyboard: "Schreiben Sie die richtige Antwort",
      },
    },
    type9: {
      title: {
        select: "Füllen Sie die Lücken aus, indem Sie das richtige Wort auswählen",
        keyboard: "Füllen Sie die Lücken aus",
      },
    },
    type8: {
      title: "Finden Sie Übereinstimmungen",
    },
    type7: {
      title: {
        text: "Schreiben Sie Ihre Antwort",
        audio: "Aufzeichnung der Audioantwort",
      },
      recordingIsNotSupported: "Die Audioaufnahme wird von Ihrem Browser nicht unterstützt",
      audioRecordingError: "Fehler bei der Audioaufnahme:",
      inputLabel: "Ihre Antwort",
      addPhotoVideo: "Foto/Video hinzufügen (bis zu %{maxCount} Stück)",
      addPhoto: "Foto hinzufügen (bis zu %{maxCount} Stück)",
      cameraInitialization: "Initialisierung...",
      change: "Ändern Sie",
      codeToApprove: "Passwort",
      homework: {
        teacherData: {
          audio: "Audiokommentar des Kursleiters",
          audioComment: "Sprachkommentar des Lehrers",
        },
      },
      addFiles: "Dateien hinzufügen",
      limitsHelperText: "Die Länge des Textes muss mindestens %{count} der Buchstaben betragen",
      photoRequired: "Fügen Sie Ihrer Antwort mindestens ein Foto oder eine Datei bei",
      photoViewerHint: "Das Bild kann mit dem Mausrad gezoomt werden",
    },
    type6: {
      title: "Zeichnen Sie das Element",
      checkButtonText: "Ich verstehe!",
    },
    type3: {
      title: "Ordnen Sie die Elemente in der richtigen Reihenfolge an",
      hint: "Ziehen Sie die folgenden Elemente hierher und legen Sie sie ab",
    },
    type5: {
      title: "Artikel auswählen",
      hint: "Wählen Sie die gewünschten Elemente am unteren Rand des Bildschirms aus (klicken Sie einfach darauf, um sie auszuwählen)",
    },
    type2: {
      title: "Wählen Sie das fehlende Wort aus",
    },
  },
  Events: {
    headNotice: "Die Ereigniszeit wird entsprechend Ihrer Zeitzone angezeigt",
    title: "Die Veranstaltungen dieser Woche",
    startTime: "Startzeit",
    finishTime: "Endzeit",
    group: "Gruppe",
    persons: "%{smart_count} Person |||| %{smart_count} Person",
    leader: "Präsentator",
    tag: "Kategorie",
    joinedCheckbox: "Mit Anmeldung",
    joined: "Ausgewählt:",
    interested: "Anmeldung",
    registered: "Angemeldet",
    enter: "Eintragen",
    limitPopupInfo: "Sie haben Ihr Anmeldelimit für die Veranstaltung erreicht",
    eventHasStarted: "Die Veranstaltung hat bereits begonnen!",
    registrationNotice: "Sie haben sich erfolgreich registriert! Die Anmeldeschaltfläche wird um %{date_and_time} aktiv sein. Nach diesem Zeitpunkt können Sie Ihre Anmeldung nicht mehr stornieren.",
    registrationNoticeNoUrl: "Sie haben sich erfolgreich angemeldet! Nach %{date_and_time} können Sie Ihre Anmeldung nicht mehr stornieren.",
    cancelRegistration: "Wollen Sie Ihre Anmeldung wirklich stornieren?",
    calendarLink: "Ein Ereignis zum Google-Kalender hinzufügen",
    status_planned: "Geplant",
    status_started: "Gestartet",
    status_completed_successfully: "Abgeschlossen",
    status_last_minute_cancellation: "Kurzfristig abgesagt",
    status_late_cancellation: "Späte Absage",
    status_canceled: "Abgesagt",
    status_moved: "Verschoben",
  },
  statistic: {
    title: "Statistik",
    points: "Punkte",
    phrases: "Phrasen",
    missions: "Missionen",
    words: "Wörter",
    time: "Zeit",
  },
  status: {
    wait_review: "In Erwartung einer Inspektion",
    on_review: "Bei der Kontrolle",
    approved: "Angenommen",
    not_approved: "Abgelehnt",
    not_approved_allow_update: "Abgelehnt (überarbeiten)",
    ai_reviewed: "Geprüft mit KI",
  },
  homeworks: {
    tabName: "Hausaufgaben",
    todo: "Auf dem Weg zur Verwirklichung",
    done: "Ausgeführt",
    topic: "Thema",
    lesson: "Lektion",
    onlyInMobileApp: "Nur in der mobilen App verfügbar",
    todoHomework: "PRÜFAUFGABE",
    postToDoButton: "Senden Sie",
    types: {
      homework_todo: "ToDo",
      exercise: "Übung",
    },
    waitAIReview: "Bitte warten, KI überprüft die Antwort.",
    dontWait: "nicht warten",
    checkingHomework: "Ich überprüfe meine Hausaufgaben",
  },
  exam: {
    popupTitle: "Eine Lektion mit Prüfung",
    popupDescr1: "Dies ist eine Lektion mit Prüfung. Studieren Sie zuerst das gesamte Zusatzmaterial und gehen Sie erst dann zu den Übungen über.",
    popupDescr2: 'Как только вы перейдете во вкладку "Übungen" начнется отсчет времени.',
    popupDescr3: 'Вкладки "Theorie" и "Video" НЕ запускают отсчет времени экзамена.',
    cancelButton: "Das nächste Mal.",
    positiveButton: "Ich sehe (%{smart_count} Versuch) |||| Ich sehe(%{smart_count} Versuche)",
    questions: "%{smart_count} Frage |||| %{smart_count} Fragen",
    oneAttempt: "Ein Versuch einer Antwort",
    timeLimit: "Zeitlimit: %{limit} Minuten",
    noPause: "Die Prüfung kann nicht ausgesetzt werden",
    progress: "Frage #%{current} von %{total}",
    closeButton: "Schließen Sie",
    viewButton: "Ergebnisse anzeigen",
    retakeButton: "Erneut versuchen (%{smart_count} Versuch) |||| Erneut versuchen (%{smart_count} Versuche)",
    finishedPopupTitle: "Prüfungsergebnis",
    examPassed: "Prüfung bestanden",
    examNotPassed: "Die Prüfung wurde nicht bestanden",
    waitHomeworks: "%{smart_count} Frage geprüft |||| %{smart_count} Fragen geprüft",
    result: "Ihr Ergebnis:",
  },
  subjects: {
    unavailable: "Der Artikel ist derzeit nicht verfügbar",
  },
  orderStatus: {
    approved: "Angenommen",
    canceled: "Abgelehnt",
    pending: "Erwartet",
  },
  notificationsTypes: {
    event: "Veranstaltung",
    invoice: "Ergebnis",
    news: "Nachrichten",
    homework: "Hausaufgaben",
    homework_todo: "Hausaufgaben_Aufgaben",
    type: {
      exercise: "Hausaufgaben",
      homework_todo: "Zu erledigende Hausaufgaben",
    },
  },
  notificationsAlert: {
    subscribe: "Benachrichtigungen einschalten",
    unsubscribe: "Benachrichtigungen ausschalten",
    instructions: "Klicken Sie auf das 🔒-Vorhängeschloss links neben der Adressleiste und ändern Sie die Auflösung der Benachrichtigung wie in der Abbildung gezeigt oder ändern Sie die allgemeinen Browsereinstellungen.",
    permissionDefault: {
      title: "Melden Sie sich für Benachrichtigungen an 🔔",
      body: "Benachrichtigungen über Statusänderungen, den Beginn von Veranstaltungen, Neuigkeiten, neue Aufgaben, die zu erledigen sind. Keine Werbung, nur Benachrichtigungen über Ihr Lernen!",
    },
    permissionDenied: {
      title: "Im Moment sind die Warnmeldungen ausgeschaltet ❌.",
      body: "Vorhin haben Sie Benachrichtigungen abgelehnt. Ohne sie können Sie sich nicht rechtzeitig über die Änderung des Status einer Aufgabe oder den Beginn eines Ereignisses informieren. Um Benachrichtigungen zu aktivieren, folgen Sie den nachstehenden Anweisungen:",
    },
    permissionGranted: {
      title: "Jetzt sind die Ausschreibungen auf ✔",
      body: "Sind Sie sicher, dass Sie auf Benachrichtigungen verzichten wollen? Ohne sie können Sie sich nicht rechtzeitig über die Änderung des Status einer Aufgabe oder den Beginn eines Ereignisses informieren. Um die Benachrichtigungen auszuschalten, folgen Sie den nachstehenden Anweisungen:",
    },
  },
  feedbackDialog: {
    sendFeedback: "Feedback senden",
    placeholder: "Erzählen Sie uns von Ihren Erfahrungen",
    defaultInstruction: "Verwenden Sie den Schieberegler zur Bewertung",
    eventInstruction: "Bewerten Sie den Verlauf der Veranstaltung",
    submitError: "Bitte wählen Sie eine Klasse",
    submitSuccess: "Dankeschön! Ihr Feedback wurde erfolgreich gesendet",
    wasNotPresent: "Ich habe die Veranstaltung nicht besucht",
    dateOfEvent: "Datum der Veranstaltung:",
  },
  congratulation: {
    mission: "Glückwunsch, Mission %{name} ist abgeschlossen!",
    missionTask: {
      title: "🎉 Glückwunsch! Die Aufgabe %{name} wurde erledigt.",
      content: "Noch <b>%{need} Aufgaben</b> bis zum Abschluss der Mission — weiter so!",
    },
  },
  accountNotFound: "Diese E-Mail-Adresse ist nicht mit einer Bildungseinrichtung verbunden. Kontaktieren Sie Ihre Schulleitung",
  demoAccess: "Möchten Sie SkillzRun für Ihr Unternehmen/Ihre Schule ausprobieren? Registrieren Sie sich, um die Plattform zu testen",
  structure: "Struktur",
  version: {
    message: "Eine neue Version der Anwendung ist verfügbar. Bitte laden Sie die Seite neu, um zu aktualisieren",
    button: "Neu laden",
  },
  missions: {
    title: "Missionen",
    startButton: "Mission starten",
    missionStarted: "Mission gestartet %{started}",
    started: "Mission gestartet!",
    tasks: {
      title: "Aufgabendetails",
    },
  },
  productCatalog: {
    title: "Produktkatalog",
    coinBalance: "Ihr Kontostand:",
    notEnoughCoins: "Nicht genügend Münzen",
    order: "Bestellen",
    orderConfirmation: "Auftragsbestätigung",
    price: "Preis:",
    remaining: "Verbleibend:",
    instructionForForm: "Um die Bearbeitung Ihrer Bestellung zu beschleunigen, füllen Sie bitte die folgenden Angaben aus",
    address: "Adresse",
    thankText: "Vielen Dank! Ihre Bestellung wurde aufgegeben.",
    pleaseWait: "Bitte warten Sie, ein Manager wird sich mit Ihnen in Verbindung setzen.",
    pleaseWaitPersona: "Bitte warten Sie auf eine SMS. Sie erhalten Ihre Sendungsnummer.",
    thankTextOffer: "Vielen Dank! Ihr Kauf ist abgeschlossen.",
    contentAvailableText: "Der Inhalt ist bereits verfügbar – Sie können ihn sofort nutzen.",
    deliveryAddress: "Geben Sie die Lieferadresse ein",
    helperText: "Geben Sie die vollständige Adresse oder die Stadt und die Nummer der Filiale von Nova Poshta/Ukrposhta an.",
    deliveryOptions: "*Die Lieferoptionen werden nach Eingang der Bestellung mit dem Manager abgestimmt.",
    validationPhoneFormat: "Die Telefonnummer muss aus 10 Ziffern bestehen und mit 0 beginnen.",
    recipientNameLabel: "Vollständiger Name",
    recipientNameRequired: "Bitte geben Sie den Namen des Empfängers ein.",
    npCityRequired: "Bitte wählen Sie eine Lieferstadt.",
    npWarehouseRequired: "Bitte wählen Sie eine Nova-Poshta-Filiale.",
    npCityLabel: "Stadt (Nova Poshta)",
    npCityPlaceholder: "Name der Stadt eingeben",
    npCitySearching: "Städte werden gesucht...",
    npCitySelectHint: "Wählen Sie eine Stadt aus der Liste",
    npCityTypeHint: "Beginnen Sie mit der Eingabe des Stadtnamens (mind. 3 Zeichen)",
    npBranchTypeDepartments: "Filialen",
    npBranchTypePostomats: "Packstationen",
    npWarehouseLabel: "Nova-Poshta-Filiale",
    npWarehousePlaceholder: "Filiale auswählen",
    npWarehouseLoading: "Filialen werden geladen...",
    npWarehouseSelectHint: "Wählen Sie eine Filiale aus der Liste",
    npWarehouseEmpty: "Für diese Stadt wurden keine Filialen gefunden",
    npWarehouseCityFirst: "Wählen Sie zuerst eine Stadt",
    inProcessing: "In Bearbeitung",
    purchased: "Gekauft",
    oneTimeAlreadyPurchased: "Dieser Artikel wurde bereits gekauft",
  },
  companyReviewTitle: "Wie wahrscheinlich ist es, dass Sie unsere Schule einem Freund oder Bekannten weiterempfehlen?",
  companyReviewText: 'Bewerten Sie auf einer Skala von 1 bis 10, wobei 1 "überhaupt nicht wahrscheinlich" und 10 "sehr wahrscheinlich" bedeutet',
  subjectReviewTitle: "Wie interessant war es für Sie, diesen Kurs auf der Plattform zu belegen?",
  subjectReviewText: 'Bewerten Sie auf einer Skala von 1 bis 10, wobei 1 "überhaupt nicht interessant" und 10 "sehr interessant" bedeutet',
  lessonsCount_one: "%{smart_count} Lektion",
  lessonsCount_few: "%{smart_count} Lektionen",
  lessonsCount_many: "%{smart_count} Lektionen",
  policySettings: {
    termsAndConditions: "Allgemeine Geschäftsbedingungen",
    refund: "Datenschutzerklärung",
  },
  promoCode: "Gutscheincode",
  promoInvalid: "Der Aktionscode ist ungültig",
};
